<div
  class="toast"
  [class]="'toast toast--' + toast.type"
  role="status"
  tabindex="0"
  (click)="close()"
  (keydown.enter)="close()"
>
  <span class="toast__icon" aria-hidden="true">
    @switch (toast.type) {
      @case ('success') {
        <svg lucideCheck class="lucide lucide-check" [size]="15" [strokeWidth]="2"></svg>
      }
      @case ('info') {
        <svg lucideInfo class="lucide lucide-info" [size]="15" [strokeWidth]="2"></svg>
      }
      @case ('warning') {
        <svg lucideTriangleAlert class="lucide lucide-triangle-alert" [size]="15" [strokeWidth]="2"></svg>
      }
      @default {
        <svg lucideCircleAlert class="lucide lucide-circle-alert" [size]="15" [strokeWidth]="2"></svg>
      }
    }
  </span>
  <div class="toast__message">{{ toast.message }}</div>
  <button type="button" class="toast__close" (click)="close()" aria-label="Close">
    <svg lucideX class="lucide lucide-x" [size]="15" [strokeWidth]="2" aria-hidden="true"></svg>
  </button>
</div>
